import React from 'react';
const facts = [{
  value: '72',
  label: 'Stacked sessions, ready to run'
}, {
  value: '432',
  label: 'Ready targets across 4 rows'
}, {
  value: '3',
  label: 'Levels: Start · Build · Stretch'
}, {
  value: '48',
  label: 'Take-home worksheets'
}];
export function SocialProofBar() {
  return <section className="w-full bg-cream" data-id="element-276" data-mp="25tdq4qqr0bwu">
      <div className="max-w-6xl mx-auto px-5 pb-14 sm:pb-16" data-id="element-277" data-mp="25uf0eszxwudi">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-cream-dark bg-cream-dark sm:grid-cols-4" data-id="element-278" data-mp="32jcyak2zl8ew">
          {facts.map(fact => <div key={fact.label} className="bg-white px-4 py-5 text-center" data-id="element-279" data-mp="2tiesbw8zmqto">
              <div className="font-display text-3xl sm:text-4xl leading-none text-plum" data-id="element-280" data-mp="2tkj6d70lp67o">
                {fact.value}
              </div>
              <div className="mt-2 text-[11px] font-semibold uppercase tracking-wider text-ink-soft" data-id="element-281" data-mp="1i3sv39hblo77">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}